import {UpdateExtensionProfileQuery} from "./queries.generated";
import {
    ExtensionProfileRuleAction,
    MutationSaveUserProfileRuleArgs,
    SecretaryMode,
    UpdateUserProfileData,
    UserProfileRuleMatchType,
} from "@/api";
import {activationTimePreparer} from "@/tools";

export function createInitialRuleData(
    profile?: UpdateExtensionProfileQuery["userProfiles"][number],
): MutationSaveUserProfileRuleArgs[] {
    if (!profile?.rules?.length) return [];

    const res: MutationSaveUserProfileRuleArgs[] = [];

    for (const rule of profile.rules) {
        res.push({
            id: rule.id,
            data: {
                priority: rule.priority,
                sourceNumber: rule.sourceNumber,
                action: rule.action as unknown as ExtensionProfileRuleAction,
                targetNumber: rule.targetNumber,
                matchType: rule.matchType as unknown as UserProfileRuleMatchType,
            },
        });
    }
    return res;
}

export function createInitialData(
    profile?: UpdateExtensionProfileQuery["userProfiles"][number],
): UpdateUserProfileData {
    if (!profile)
        return {
            settings: {
                activationTimes: [],
                specialDays: [],
            },
            anonymousCallRejection: false,
            callForwardBusy: false,
            callForwardBusyNumber: "",
            callForwardFault: false,
            callForwardFaultNumber: "",
            callForwardNoanswer: false,
            callForwardNoanswerNumber: "",
            callForwardNoanswerTimeout: 30,
            callForwardUnavailable: false,
            callForwardUnavailableNumber: "",
            callForwardUnconditional: false,
            callForwardUnconditionalNumber: "",
            callingNamePresentation: false,
            callingNumberPresentationRestriction: false,
            connectedNumberPresentationRestriction: false,
            doNotDisturb: false,
            locked: false,
            name: "",
            parallelRinging: false,
            parallelRingingNumber: "",
            rejectDivertedCalls: false,
            secretaryMode: SecretaryMode.SecretaryOnly,
            stickyProfile: false,
        };

    const preparedActivationTimes = activationTimePreparer(profile.activationTimes);

    return {
        settings: {
            activationTimes: preparedActivationTimes,
            specialDays: profile.specialDays,
        },
        anonymousCallRejection: profile.anonymousCallRejection,
        callForwardBusy: profile.callForwardBusy,
        callForwardBusyNumber: profile.callForwardBusyNumber,
        callForwardFault: profile.callForwardFault,
        callForwardFaultNumber: profile.callForwardFaultNumber,
        callForwardNoanswer: profile.callForwardNoanswer,
        callForwardNoanswerNumber: profile.callForwardNoanswerNumber,
        callForwardNoanswerTimeout: profile.callForwardNoanswerTimeout,
        callForwardUnavailable: profile.callForwardUnavailable,
        callForwardUnavailableNumber: profile.callForwardUnavailableNumber,
        callForwardUnconditional: profile.callForwardUnconditional,
        callForwardUnconditionalNumber: profile.callForwardUnconditionalNumber,
        callingNamePresentation: profile.callingNamePresentation,
        callingNumberPresentationRestriction: profile.callingNumberPresentationRestriction,
        connectedNumberPresentationRestriction: profile.connectedNumberPresentationRestriction,
        doNotDisturb: profile.doNotDisturb,
        locked: profile.locked,
        name: profile.name,
        parallelRinging: profile.parallelRinging,
        parallelRingingNumber: profile.parallelRingingNumber,
        rejectDivertedCalls: profile.rejectDivertedCalls,
        secretaryMode: profile.secretaryMode as unknown as SecretaryMode,
        stickyProfile: profile.stickyProfile,
    };
}
